<template>
  <div class="login-page min-vh-100 d-flex align-items-center py-4">
    <loading v-if="cargando" />
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10 col-xl-9">
          <div class="login-card shadow border-0 overflow-hidden bg-white">
            <div class="row no-gutters">
              <!-- Formulario -->
              <div
                class="col-lg-6 d-flex align-items-center order-2 order-lg-1"
              >
                <div class="w-100 px-4 py-5 px-md-5">
                  <div class="mb-4">
                    <p
                      class="text-uppercase text-muted small font-weight-bold mb-2 letter-spacing"
                    >
                      Bienvenido a
                    </p>
                    <div class="row align-items-center mb-2">
                      <div class="col-8 col-sm-7">
                        <img
                          src="/img/geopark-logo.svg"
                          alt="Geopark"
                          class="img-fluid"
                        />
                      </div>
                    </div>
                    <p class="text-muted small mb-0">
                      Ingresa para gestionar la operación de Support 7-24 en
                      tiempo real.
                    </p>
                  </div>

                  <form @submit.prevent>
                    <div class="form-group mb-3">
                      <div class="input-group login-input">
                        <div class="input-group-prepend">
                          <span
                            class="input-group-text border-0 bg-transparent"
                          >
                            <i class="fas fa-user text-muted"></i>
                          </span>
                        </div>
                        <input
                          type="email"
                          class="form-control border-0 bg-transparent shadow-none"
                          v-model="form.email"
                          placeholder="Correo electrónico"
                          :class="
                            $v.form.email.$invalid ? 'is-invalid' : 'is-valid'
                          "
                          @input="checkEmail()"
                          autocomplete="username"
                        />
                      </div>
                    </div>

                    <div class="form-group mb-3">
                      <div class="input-group login-input">
                        <div class="input-group-prepend">
                          <span
                            class="input-group-text border-0 bg-transparent"
                          >
                            <i class="fas fa-lock text-muted"></i>
                          </span>
                        </div>
                        <input
                          :type="showPassword ? 'text' : 'password'"
                          class="form-control border-0 bg-transparent shadow-none"
                          v-model="form.password"
                          placeholder="Contraseña"
                          :class="
                            $v.form.password.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                          autocomplete="current-password"
                        />
                        <div class="input-group-append">
                          <button
                            type="button"
                            class="btn border-0 bg-transparent text-muted"
                            @click="showPassword = !showPassword"
                            tabindex="-1"
                          >
                            <i
                              :class="
                                showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'
                              "
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="text-right mb-4">
                      <router-link
                        to="/ForgotPassword"
                        class="small font-weight-bold login-link"
                      >
                        ¿Olvidaste tu clave?
                      </router-link>
                    </div>

                    <button
                      type="button"
                      class="btn btn-login btn-block py-2 font-weight-bold text-white"
                      v-if="!$v.form.$invalid && password_at && mostrarSave"
                      @click="[validateAndSubmit(), login()]"
                    >
                      INGRESAR
                    </button>
                    <button
                      type="button"
                      data-toggle="modal"
                      data-target="#modal-form-validate-2FA"
                      class="btn btn-login btn-block py-2 font-weight-bold text-white"
                      v-if="
                        !$v.form.$invalid &&
                          ipDiff &&
                          !password_at &&
                          mostrarSave
                      "
                      @click="validateAndSubmit()"
                    >
                      INGRESAR
                    </button>
                    <button
                      type="button"
                      class="btn btn-login btn-block py-2 font-weight-bold text-white"
                      v-if="
                        !$v.form.$invalid &&
                          !ipDiff &&
                          !password_at &&
                          mostrarSave
                      "
                      @click="[validateAndSubmit(), login()]"
                    >
                      INGRESAR
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary btn-block py-2 font-weight-bold"
                      v-if="$v.form.$invalid || !mostrarSave"
                      disabled
                    >
                      COMPLETA TUS DATOS
                    </button>
                  </form>

                  <div class="text-center mt-5">
                    <div class="row justify-content-center">
                      <div class="col-7 col-sm-6">
                        <img
                          src="/img/Logo-Support-7-24.png"
                          alt="Support 7-24"
                          class="img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Panel derecho -->
              <div
                class="col-lg-6 d-none d-lg-block order-1 order-lg-2 login-hero p-0"
              >
                <div
                  id="carouselLoginHero"
                  class="carousel slide h-100"
                  data-ride="carousel"
                  data-interval="4000"
                >
                  <div class="carousel-inner h-100">
                    <div class="carousel-item active h-100">
                      <div
                        class="login-hero-slide"
                        style="background-image: url('/img/banner4sos.png')"
                      ></div>
                      <div class="carousel-caption login-hero-caption">
                        <p class="font-weight-bold mb-0">
                          Support 7-24 · Hidrocarburos
                        </p>
                      </div>
                    </div>
                    <div class="carousel-item h-100">
                      <div
                        class="login-hero-slide"
                        style="background-image: url('/img/banner1sos.jpg')"
                      ></div>
                      <div class="carousel-caption login-hero-caption">
                        <p class="font-weight-bold mb-0">
                          Support 7-24 · TEP
                        </p>
                      </div>
                    </div>
                    <div class="carousel-item h-100">
                      <div
                        class="login-hero-slide"
                        style="background-image: url('/img/banner2sos.jpg')"
                      ></div>
                      <div class="carousel-caption login-hero-caption">
                        <p class="font-weight-bold mb-0">
                          Support 7-24 · TIF
                        </p>
                      </div>
                    </div>
                    <div class="carousel-item h-100">
                      <div
                        class="login-hero-slide"
                        style="background-image: url('/img/banner3sos.jpg')"
                      ></div>
                      <div class="carousel-caption login-hero-caption">
                        <p class="font-weight-bold mb-0">
                          Support 7-24 · Carga seca
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="login-hero-overlay">
                    <div
                      class="login-hero-brand px-4 py-4 text-center text-white"
                    >
                      <div class="row justify-content-center mb-3">
                        <div class="col-10">
                          <img
                            src="/img/logo-sos-negativo.png"
                            alt="SOS Contingencias"
                            class="img-fluid login-hero-logo"
                          />
                        </div>
                      </div>
                      <h2 class="font-weight-bold mb-3">GEOPARK</h2>
                      <p class="mb-0 px-md-2 small">
                        Plataforma Support 7-24 para la gestión operativa de
                        hidrocarburos, TEP, TIF y carga seca.
                      </p>
                    </div>
                  </div>

                  <ol class="carousel-indicators">
                    <li
                      data-target="#carouselLoginHero"
                      data-slide-to="0"
                      class="active"
                    ></li>
                    <li data-target="#carouselLoginHero" data-slide-to="1"></li>
                    <li data-target="#carouselLoginHero" data-slide-to="2"></li>
                    <li data-target="#carouselLoginHero" data-slide-to="3"></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Validación Doble Factor -->
    <div
      class="modal fade"
      id="modal-form-validate-2FA"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content border-0 shadow">
          <div class="modal-header bg-geopark text-white">
            <h5 class="modal-title mb-0">
              <i class="fas fa-shield-alt mr-2"></i>
              Verificación de ingreso
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-warning border-warning">
              <h6 class="mb-1">
                <i class="fas fa-exclamation-triangle mr-1"></i>
                Atención
              </h6>
              <p class="mb-0 small">
                Se acaba de enviar un correo con el código de seguridad. El
                código debe ser numérico.
              </p>
            </div>
            <p class="text-center text-muted small mb-3">
              Ingresa el código de 7 dígitos
            </p>
            <div
              class="row justify-content-center align-items-center no-gutters"
            >
              <template v-for="(input, index) in inputs">
                <div :key="'wrap-' + index" class="col-1 px-1">
                  <input
                    type="text"
                    maxlength="1"
                    class="form-control form-control-sm text-center px-0"
                    v-model="inputs[index]"
                    @input="moveToNext(index)"
                    @keydown="moveToPrevious(index, $event)"
                    @paste="handlePaste($event, index)"
                    :ref="'input-' + index"
                    :class="
                      inputs[index] != '' &&
                      inputs[index] >= 0 &&
                      inputs[index] <= 9
                        ? 'border border-success'
                        : 'border border-danger'
                    "
                  />
                </div>
                <div
                  v-if="index < inputs.length - 1"
                  :key="'dash-' + index"
                  class="col-auto text-muted px-0"
                >
                  -
                </div>
              </template>
            </div>
          </div>
          <div
            class="modal-footer justify-content-center"
            v-show="inputs.every((cod) => cod != '' && cod >= 0 && cod <= 9)"
          >
            <button
              type="button"
              class="btn btn-login text-white px-4"
              @click="login()"
            >
              Verificar
              <i class="fas fa-thumbs-up ml-1"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.login-page {
  background: linear-gradient(to bottom right, #b11f2b, #6f7174);
}

.login-card {
  border-radius: 1.25rem;
  min-height: 560px;
}

.letter-spacing {
  letter-spacing: 0.08em;
}

.login-input {
  background: #f1f3f5;
  border-radius: 2rem;
  overflow: hidden;
  border: 1px solid transparent;
}

.login-input:focus-within {
  border-color: #b11f2b;
  background: #fff;
}

.login-input .form-control.is-invalid,
.login-input .form-control.is-valid {
  background-image: none;
}

.login-link {
  color: #b11f2b;
}

.login-link:hover {
  color: #8f1822;
  text-decoration: none;
}

.btn-login,
.bg-geopark {
  background-color: #b11f2b;
  border-color: #b11f2b;
}

.btn-login {
  border-radius: 2rem;
  box-shadow: 0 8px 18px rgba(177, 31, 43, 0.28);
}

.btn-login:hover,
.btn-login:focus {
  background-color: #8f1822;
  border-color: #8f1822;
  color: #fff;
}

.login-hero {
  position: relative;
  min-height: 560px;
  overflow: hidden;
}

.login-hero .carousel,
.login-hero .carousel-inner,
.login-hero .carousel-item {
  min-height: 560px;
}

.login-hero .carousel-item {
  position: relative;
}

.login-hero-slide {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-size: cover;
  background-position: center;
}

.login-hero-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

/* Contenedor transparente sobre las imágenes del carrusel */
.login-hero-brand {
  width: 85%;
  max-width: 360px;
  background: transparent;
}

/* Fondo negro del PNG se vuelve transparente */
.login-hero-logo {
  mix-blend-mode: screen;
}

.login-hero-brand h2,
.login-hero-brand p {
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.65);
}

.login-hero-caption p {
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.55);
}

.login-hero-caption {
  bottom: 3.25rem;
  left: 0;
  right: 0;
  z-index: 3;
  padding: 0 1.5rem;
}

.login-hero .carousel-indicators {
  bottom: 1rem;
  z-index: 4;
}

.login-hero .carousel-indicators li {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.45);
}

.login-hero .carousel-indicators .active {
  background-color: #fff;
}
</style>

<script>
import { required, email } from "vuelidate/lib/validators";
import Loading from "../components/Loading";
import { PublicClientApplication } from "@azure/msal-browser";
import axios from "axios";
import moment from "moment";
// reCAPTCHA deshabilitado temporalmente: falta VUE_APP_RECAPTCHA_SITE_KEY en .env
// import { load as loadRecaptcha } from "recaptcha-v3";

export default {
  components: {
    Loading,
  },
  data: () => ({
    form: {
      email: "",
      password: "",
    },
    inputs: Array(7).fill(""),
    code: null,
    cargando: false,
    account: null,
    user: null,
    ipDiff: false,
    password_at: false,
    mostrarSave: false,
    showPassword: false,
  }),
  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },

  async created() {
    this.$msalInstance = new PublicClientApplication(
      this.$store.state.msalConfig,
    );
  },

  mounted() {
    const accounts = this.$msalInstance.getAllAccounts();
    if (accounts.length == 0) {
      return;
    }
    this.account = accounts[0];
    this.loginAzure(this.account);
  },

  methods: {
    validateAndSubmit() {
      this.inputs = Array(7).fill("");
      if (this.ipDiff && !this.password_at) {
        this.enviarToken();
      }

      // reCAPTCHA deshabilitado temporalmente: falta VUE_APP_RECAPTCHA_SITE_KEY en .env
      // loadRecaptcha(process.env.VUE_APP_RECAPTCHA_SITE_KEY)
      //   .then((instance) => instance.execute("login"))
      //   .then((token) => {
      //     this.form.recaptcha = token;
      //   });
      this.form.recaptcha = null;
    },

    /* async orionVehiculos() {
      this.$refs.closeModal.click();
      await this.$router.replace("/SolicitudVehiculo");
    },

    async orionConductores() {
      this.$refs.closeModal.click();
      await this.$router.replace("/SolicitudConductor");
    }, */

    moveToNext(index) {
      if (this.inputs[index].length === 1 && index < this.inputs.length - 1) {
        this.$refs[`input-${index + 1}`][0].focus();
      }
    },

    moveToPrevious(index, event) {
      if (event.key === "Backspace" && this.inputs[index] === "" && index > 0) {
        setTimeout(() => {
          this.$refs[`input-${index - 1}`][0].focus();
        }, 0);
      }
    },

    handlePaste(event, index) {
      const pastedData = event.clipboardData.getData("text");
      const digits = pastedData.split("").slice(0, this.inputs.length); // Limitar a la longitud de inputs

      // Distribuir los números en cada input
      digits.forEach((digit, i) => {
        if (i < this.inputs.length) {
          this.$set(this.inputs, i, digit);
        }
      });

      // Evitar el comportamiento predeterminado del pegado
      event.preventDefault();
      // Mover el foco al siguiente input
      this.moveToNext(index);
    },

    enviarToken() {
      let me = this;
      this.cargando = true;
      axios
        .post("/api/verificacionFa", me.form)
        .then((response) => {
          me.cargando = false;
          if (response.data.estado == 1) {
            this.$refs.closeModal.click();
            this.$swal({
              icon: "error",
              title: "Oops...",
              text:
                "Si los datos introducidos son correctos, se enviará un correo electrónico con un enlace de confirmación.",
            });
            me.cargando = false;
          } else {
            me.$swal({
              icon: "success",
              title: response.data.msg,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            me.cargando = false;
          }
          me.cargando = false;
        })
        .catch((e) => {
          me.$swal({
            icon: "error",
            title: "Ocurrió un error, vuelva a intentarlo... " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          me.cargando = false;
        });
    },

    async login() {
      this.cargando = true;
      this.form.code = this.inputs.join("");
      this.inputs = Array(7).fill("");
      await this.$store.dispatch("login", this.form);
      this.cargando = false;

      if (this.$store.getters.isAuthenticated) {
        this.$refs.closeModal.click();
        // Verificar si el usuario tiene SOLO el país 3 (Argentina) y redirigir directamente
        const user = this.$store.getters.getUser;
        if (user && user.paises && user.paises.length > 0) {
          // Solo redirigir si tiene SOLO el país 3 (Argentina)
          const tieneSoloPaisArgentina =
            user.paises.length === 1 && user.paises[0].id === 3;
          if (tieneSoloPaisArgentina) {
            // Cargar el menú de la línea de negocio 15 (Argentina) antes de redirigir
            this.cargando = true;
            await this.$store.dispatch("getMenus", 15);
            await this.$store.dispatch(
              "getRoutes",
              this.$store.getters.getMenus,
            );
            await this.$store.dispatch("setRoutes");
            this.cargando = false;
            return this.$router.replace("/OperacionArgentina");
          }
        }
        return this.$router.replace("/");
      } else {
        const errorType = this.$store.getters.getErrors;
        switch (errorType) {
          case "recaptcha":
            this.$swal({
              icon: "error",
              title: "Oops...",
              text:
                "Si los datos introducidos son correctos, se enviará un correo electrónico con un enlace de confirmación.",
            });
            break;
          case "password_updated_at":
            this.$swal({
              icon: "error",
              title: "Oops...",
              text:
                "Ha pasado mucho tiempo sin actualizar la contraseña, por favor cámbiela!",
            });
            return this.$router.push({
              name: "ResetPassword",
              params: {
                token: "token",
                email: this.form.email,
              },
            });
          case "status":
          case "fecha_expire":
          case "autentication_code":
          case "estado_empresa":
            this.$swal({
              icon: "error",
              title: "Oops...",
              text:
                "Si los datos introducidos son correctos, se enviará un correo electrónico con un enlace de confirmación.",
            });
            break;
          case "email":
            this.$refs.closeModal.click();
            this.$swal({
              icon: "error",
              title: "Oops...",
              text: this.$store.getters.getMensajeLogin,
            });
            break;
          default:
            this.$swal({
              icon: "error",
              title: "Oops...",
              text:
                "Si los datos introducidos son correctos, se enviará un correo electrónico con un enlace de confirmación.",
            });
        }
      }
    },

    async loginAzure(cuentaAzure) {
      this.cargando = true;
      await this.$store.dispatch("loginAzure", cuentaAzure);
      if (this.$store.getters.isAuthenticated) {
        this.cargando = false;
        // Verificar si el usuario tiene SOLO el país 3 (Argentina) y redirigir directamente
        const user = this.$store.getters.getUser;
        if (user && user.paises && user.paises.length > 0) {
          // Solo redirigir si tiene SOLO el país 3 (Argentina)
          const tieneSoloPaisArgentina =
            user.paises.length === 1 && user.paises[0].id === 3;
          if (tieneSoloPaisArgentina) {
            // Cargar el menú de la línea de negocio 15 (Argentina) antes de redirigir
            this.cargando = true;
            await this.$store.dispatch("getMenus", 15);
            await this.$store.dispatch(
              "getRoutes",
              this.$store.getters.getMenus,
            );
            await this.$store.dispatch("setRoutes");
            this.cargando = false;
            return this.$router.replace("/OperacionArgentina");
          }
        }
        return this.$router.replace("/");
      } else {
        this.cargando = false;
        if (this.$store.getters.getErrors === "status") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text:
              "Si los datos introducidos son correctos, se enviará un correo electrónico con un enlace de confirmación.",
          });
        } else if (this.$store.getters.getErrors === "estado_empresa}") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text:
              "Si los datos introducidos son correctos, se enviará un correo electrónico con un enlace de confirmación.",
          });
        } else if (this.$store.getters.getErrors === "email") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: this.$store.getters.getMensajeLogin,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text:
              "Si los datos introducidos son correctos, se enviará un correo electrónico con un enlace de confirmación.",
          });
        }
      }
    },

    async SignIn() {
      await this.$msalInstance
        .loginPopup({})
        .then(() => {
          const myAccounts = this.$msalInstance.getAllAccounts();
          this.account = myAccounts[0];
          //logueo con azure
          this.loginAzure(this.account);
        })
        .catch((error) => {
          console.error(`error during authentication: ${error}`);
        });
    },

    async SignOut() {
      await this.$msalInstance
        .logout({})
        .then(() => {
          this.$emitter.emit("logout", "logging out");
        })
        .catch((error) => {
          console.error(error);
        });
    },

    async checkEmail() {
      if (
        this.$v.form.email.$pending === false &&
        this.$v.form.email.$invalid === false
      ) {
        await this.valUser(); // Llamar la validación solo si el email es válido
      }
    },

    async valUser() {
      let ip = null;
      this.ipDiff = false;
      this.password_at = false;
      this.mostrarSave = false;
      await axios
        .get("/api/userValid", {
          params: this.form,
        })
        .then((response) => {
          let user = response.data.dataUser;
          ip = response.data.miIp;

          let fecha_ant = moment()
            .subtract(3, "months")
            .format("YYYY-MM-DD");
          let fecha_actual = new Date(fecha_ant);
          if (user) {
            let password_updated_at = new Date(user.password_updated_at);
            if (fecha_actual > password_updated_at) {
              this.password_at = true;
            }
            if (user.session && ip != user.session.ip_address) {
              this.ipDiff = true;
            }
          }
        });

      this.mostrarSave = true;
    },
  },

  /* computed: {    
  }, */
};
</script>
